import {
  Component,
  HostBinding,
  Input,
  AfterViewInit,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

import { EmailPreviewRefreshService } from '../../services/email-preview-refresh.service';

// Interface
export interface SimpleTableBlock {
  tableData: SimpleTableRow[];
}

export interface SimpleTableRow {
  label?: string;
  value?: string;
}

// Default blank value
export const blankSimpleTableBlock: SimpleTableBlock = {
  tableData: [{ label: '', value: '' }],
};

@Component({
  selector: 'email-simple-table-block',
  templateUrl: './simple-table-block.component.html',
  styleUrls: ['./simple-table-block.component.scss'],
  standalone: false,
})
export class SimpleTableBlockComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class') class = 'email-simple-table-block';
  @Input() content: SimpleTableBlock;
  @ViewChild('blockInputs') blockInputs: NgForm;

  @Output() isBlockValid = new EventEmitter<boolean>();

  private readonly subscriptions: Subscription[] = [];

  constructor(private emailPreview: EmailPreviewRefreshService) {}

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.blockInputs.form.valueChanges.subscribe(() => {
        this.emailPreview.refresh();
      }),
      this.blockInputs.statusChanges.subscribe((status) => {
        this.isBlockValid.emit(status === 'VALID');
      }),
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fixFieldLosingFocusWhenTyping(index: any, item: any): any {
    // https://stackoverflow.com/a/60945501/7338673
    return index;
  }

  addRow(): void {
    this.content.tableData.push({ label: '', value: '' });
  }
  removeRow(index: number): void {
    this.content.tableData.splice(index, 1);
    if (this.content.tableData.length === 0) {
      this.addRow();
    }
  }
}
